import React from "react";

export const EmptyChatBox = ({}) => {
  return (
    <div className="conversation-container justify-items-center content-center">
      <span className="pb-4 font-bold text-xl">No Chats Yet!</span>
      <p className="mb-8 opacity-70 text-md">
        No conversations available. Click on the "New" button to create your
        first conversation
      </p>
    </div>
  );
};
